module.exports = __webpack_public_path__ + "img/cover-minigame-bg-mobile.a20d9b0d.jpg";